//// Selected Vehicle
export const SET_SIZE_SELECTIONS = 'SET_SIZE_SELECTIONS';


//// Vehicle Options
export const POPULATE_WIDTH_OPTIONS = 'POPULATE_WIDTH_OPTIONS';
export const POPULATE_RATIO_OPTIONS = 'POPULATE_RATIO_OPTIONS';
export const POPULATE_DIAMETER_OPTIONS = 'POPULATE_DIAMETER_OPTIONS';


export const mutations = {
    setSelectedWidth: (state, width) => state.selected.width = width,
    setSelectedRatio: (state, ratio) => state.selected.ratio = ratio,
    setSelectedDiameter: (state, diameter) => state.selected.diameter = diameter,
    [SET_SIZE_SELECTIONS](state, selections) {
        let oldSelections = state.selections;
        // Clear out old fmk value, because it will be invalidated if selections change
        if (typeof oldSelections.fmk != 'undefined') delete oldSelections.fmk;
        
        state.selections = {...oldSelections, ...selections};
    },
    
    [POPULATE_WIDTH_OPTIONS](state, widths) {
        let oldOptions = state.options;
        state.options = {...oldOptions, widths};
    },
    
    [POPULATE_RATIO_OPTIONS](state, ratios) {
        let oldOptions = state.options;
        state.options = {...oldOptions, ratios};
    },
    
    [POPULATE_DIAMETER_OPTIONS](state, diameters) {
        let oldOptions = state.options;
        state.options = {...oldOptions, diameters};
    },

};